import { getAccessToken } from '../../../selectors/biasharaFlexi/payment';
import { getIsApiPending } from '../../../selectors/biasharaFlexi/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/biasharaFlexi/payloadCollection';
import { getCompanyIdValue, getQuoteIdValue } from '../../../selectors/biasharaFlexi/companyDetails';
import { getEmployeeScvFile, getEmployeesList } from '../../../selectors/biasharaFlexi/employeeDetails';
import { getIsPayNow } from '../../../selectors/biasharaFlexi/coverDetails';
import axios from 'axios';
import { apiTransitionBiasharaFlexiEmployeeDetailsForm } from '../../../actions/biasharaFlexi/employeeDetails';

export const saveEmployeeDetails = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            store.dispatch(apiTransitionBiasharaFlexiEmployeeDetailsForm.pending());
            try {
                const resp = await makeSubmission(store.getState());

                if (resp.data) {
                    store.dispatch(apiTransitionPayloadCollection.initial());
                    store.dispatch(apiTransitionBiasharaFlexiEmployeeDetailsForm.success());
                }
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionPayloadCollection.initial());
                store.dispatch(apiTransitionBiasharaFlexiEmployeeDetailsForm.failure());
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state) => {
    const cid = getCompanyIdValue(state);
    const qid = getQuoteIdValue(state);
    const employees = getEmployeesList(state);
    const employeesCsv = getEmployeeScvFile(state);
    const isPayNow = getIsPayNow(state);

    const arr = employees.map((emp) => {
        return {
            firstName: emp.first_name,
            lastName: emp.surname,
            dateofBirth: emp.dob,
            employmentDate: emp.employment_date,
            phoneNumber: emp.phone_number,
            kraPin: emp.kra_pin,
            employeeId: emp.employee_id,
        };
    });

    const payload = {
        companyId: cid.value,
        quoteId: qid.value,
        employeeCsv: employeesCsv ? employeesCsv?.base64File : 'N/A',
        employees: employeesCsv ? 'N/A' : isPayNow ? 'N/A' : arr,
    };

    return {
        ...payload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/biashara-flexi/save-employee-details';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};
